import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { AuditRow } from "../../../models/AuditRow";
import { formatConsumption } from "../../../utils/format";
import { EmptyValue } from "../../common/EmptyValue";
import { rowConsumption } from "../rowValues";

/** Consumption with its unit in the cell, since mixed fleets share one table. */
export function ConsumptionCell({ row }: GridRenderCellParams<AuditRow>) {
  const { t, i18n } = useTranslation();
  const { value, fuelType } = rowConsumption(row);
  if (!fuelType) return <EmptyValue title={t("logbookAudit.consumption.noFuelGroup")} />;
  if (value == null) return <EmptyValue title={t("logbookAudit.consumption.noData")} />;
  const text = <span style={{ fontVariantNumeric: "tabular-nums" }}>{formatConsumption(value, fuelType, i18n.language)}</span>;
  if (fuelType === "electric") return text;
  return <Tooltip title={t("logbookAudit.source.fuelUsedEvents")}>{text}</Tooltip>;
}
